import { IonAccordionGroup, IonCol, IonLoading, IonRow } from "@ionic/react";
import { useEffect, useRef, useState } from "react";
import { makeGETRequest, makePOSTRequest } from "../../request/rawRequest";
import { Comp } from "../../types/comp";
import { getCurrentTechnoOrDisconnect } from "../../variables/jobDictionnary";
import BasicPage from "../BasicPage/BasicPage";
import "../IonColor/color.css";
import AccordionItem from "../List/AccordionList";
import "../generalCSS/stylesheet.css";

interface ContainerProps {}

const loadTheme = async (idComp: Array<any>): Promise<any> => {
  let themes: any = null;
  if (!idComp || idComp[0] == "") {
    return;
  }
  await makePOSTRequest("/themes", { _id: idComp }).then((response) => {
    themes = response;
  });
  return themes;
};

const competences = async (): Promise<Comp[]> => {
  const competences: Comp[] = [];

  await makeGETRequest(
    "/skills/videotutorial/unique?type=" +
      getCurrentTechnoOrDisconnect() +
      "&pole=" +
      localStorage.getItem("pole")
  ).then(async (response) => {
    for (let i: number = 0; i < response.length; i++) {
      competences.push({
        id: response[i]._id,
        name: response[i].name,
        themesID: Object.is(response[i].id_themes, [""])
          ? null
          : response[i].id_themes,
        index: response[i].index ?? i,
        themes: (await loadTheme(response[i].id_themes)) ?? undefined,
      });
    }
    competences.sort((a, b) => a.index - b.index);
  });

  return competences;
};

const Generique: React.FC<ContainerProps> = () => {
  const [compList, setCompList] = useState<Comp[]>([]);
  const comptemp: Promise<Comp[]> = competences();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const title = useRef("");

  useEffect(() => {
    title.current = "Pratique";
    title.current +=
      getCurrentTechnoOrDisconnect() === "pat"
        ? " - Pole " + localStorage.getItem("pole")
        : "";
    comptemp.then((response) => {
      setCompList(response);
    });
  }, []);

  useEffect(() => {
    if (compList.length > 0) setIsLoading(false);
  }, [compList]);

  return (
    <BasicPage pathReturn title={title.current}>
      <IonLoading isOpen={isLoading} cssClass="loading" />
      <IonRow className="ion-justify-content-center">
        <IonCol>
          <IonAccordionGroup>
            {compList.map((comp, i) => (
              <AccordionItem
                key={i + "" + comp.toString()}
                name={comp.name}
                themesID={comp.themes}
                compID={comp.id}
                generique
              />
            ))}
          </IonAccordionGroup>

          <div style={{ height: "50px" }}></div>
          {localStorage.getItem("techno") === "pat" && (
            <IonCol
              className="ion-justify-content-end flex"
              onClick={() => {
                localStorage.setItem(
                  "pole",
                  localStorage.getItem("pole") === "1" ? "2" : "1"
                );
                window.location.reload();
              }}
            >
              <span className="btn fit-content padding ion-align-items-center">
                Pratique pôle {localStorage.getItem("pole") === "1" ? 2 : 1}
              </span>
            </IonCol>
          )}
        </IonCol>
      </IonRow>
    </BasicPage>
  );
};

export default Generique;
